import { UserPic } from 'platform-components/src/components/user-pic/user-pic';
import { getMe } from 'platform-components/src/components/user/selectors';
import React from 'react';
import { useSelector } from 'react-redux';

interface Props {
    mix?: string;
}

export const UserIcon = ({ mix }: Props) => {
    const me = useSelector(getMe);
    const avatarId = me?.avatar || undefined;

    return <UserPic avatarId={avatarId} className={mix} size={'m'} />;
};
